// components
import { Navbar1 } from 'components/navbars';
import BackToTop from 'components/BackToTop';
import { Footer1, Footer2 } from 'components/footer';

import Hero from './Hero';
import ContactUs from './ContactUs';
import CookiesDemo from './CookiesDemo';
import { Helmet } from 'react-helmet-async';

const Contact = () => {

    return (
        <>
            <div className="header-7">
                <Hero />
            </div>
            {/* contact us */}
            <ContactUs />
            <CookiesDemo />
            {/* <BackToTop /> */}
            {/* </div> */}
        </>
    );
};

export default Contact;
